import { log } from 'log';
import { useSelector } from 'react-redux';
import { path, pick } from 'js/utils/ramda.util';
import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useAppSelector } from 'js/store/hooks';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';

export const MetaTags = () => {
    const isMounted = useIsMounted();
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const [metaData, setMetaData] = useState(null);
    const { relativeCanonical, description, keywords, title, robots } = metaData || {};
    const { sportsbookRootURL } = useAppSelector(pick(['sportsbookRootURL']));

    useEffect(() => {
        if (!isAppInitialized) {
            return;
        }

        try {
            window.Sportsbook?.setListener('PAGE_METATAGS_UPDATED', (metadata) => {
                if (isMounted()) {
                    setMetaData(metadata);
                }
            });
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] Meta Tags Subscription error', error);
        }
    }, [isAppInitialized, isMounted, setMetaData]);

    return (
        metaData && (
            <Helmet>
                {title && (<title>{title}</title>)}
                {description && (<meta name="description" content={description}/>)}
                {keywords && (<meta name="keywords" content={keywords}/>)}
                {robots && (<meta name="robots" content={robots}/>)}
                {relativeCanonical && (<link rel="canonical" href={`${location.origin}${sportsbookRootURL}${relativeCanonical}`}/>)}
            </Helmet>
        )
    );
};
